import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import pt from 'vuetify/lib/locale/pt';
import colors from '@/assets/scss/_variables.scss';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { pt },
      current: 'pt',
    },
    theme: {
        options: { customProperties: true },

        themes: {
            // MC-337 - Alice Serina - 10/02/2026
            // Adding custom colors to the Vuetify theme to be used in the application
            light: {
                primary: colors.primary,
                success: colors.success,
                error: colors.error,
                warning: colors.warning,
                bg_primary: colors.bg_primary,
                bg_secondary: colors.bg_secondary,
                text_primary: colors.text_primary,
                text_secondary: colors.text_secondary,
                text_muted: colors.text_muted,
                // info: colors.info,

            },
        },
    },
});
